module.exports = "class SuspenseTimeout extends React.Component {\n  render() {\n    const { data } = this.props\n    if (true) {/* do nothing */}\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./public/code/suspense.js
// module id = 389
// module chunks = 0